import { render, staticRenderFns } from "./BomEdit.vue?vue&type=template&id=55b979f0&"
import script from "./BomEdit.vue?vue&type=script&lang=js&"
export * from "./BomEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports